module.exports = __webpack_public_path__ + "img/home-07-cosmo-02-timeline-03.e57b2a46.jpg";